export const RESOUCE_TYPES_OPTIONS = [
  { value: "course-group", label: "Grupa kursów" },
  { value: "course", label: "Kurs" },
  { value: "category", label: "Kategoria" },
  { value: "general", label: "Ogólny" },
  { value: "user", label: "Użytkownik" },
];

export const DISCOUNT_MODE_OPTIONS = [
  { value: "standard", label: "Standardowy" },
  { value: "bundle", label: "Pakiet kursów" },
];

export const BUNDLE_REQUIREMENT_MODE_OPTIONS = [
  { value: "courseList", label: "Konkretne kursy (edycje)" },
  { value: "courseGroupList", label: "Grupy kursów" },
  { value: "categoryMinCount", label: "Min. liczba kursów z kategorii" },
];
